import { createMuiTheme, responsiveFontSizes } from "@material-ui/core";
const defaultTheme = createMuiTheme();
const basetheme = createMuiTheme({
    palette: {
        primary: {
            main: "#0060A6", //Tracerco dark blue
            light: "#87c3eb", //Tracerco light blue
            dark: "#1E22AA",
            contrastText: "#FFFFFF"
        },
        secondary: {
            main: "#EBEBEB",
            light: "#F5F5F5",
            dark: "#505050",
            contrastText: "#e3f2fd"
        }
    },
    spacing: 4,
    typography: {
        allVariants: {
            textRendering: "optimizeLegibility",
            fontWeight: 400
        },
        h1: {
            fontSize: "3rem",
            fontWeight: 700
        },
        h2: {
            fontSize: "1.9rem",
            fontWeight: 700
        },
        h3: {
            fontSize: "1.8rem",
            fontWeight: 500
        },
        h4: {
            fontSize: "1.7rem",
            fontWeight: 500
        },
        h5: {
            fontWeight: 500
        },
        body1: {
            fontStyle: "normal"
        },
        body2: {
            fontStyle: "normal"
        },
        subtitle1: {
            fontSize: "1.3rem",
            lineHeight: 1.2
        },
        subtitle2: {
            fontSize: "0.9rem"
        },
        button: {
            textTransform: "none",
            fontWeight: 700
        },
        fontFamily: "JMSans, Helvetica Neue, Arial, sans-serif"
    },

    overrides: {
        MuiAppBar: {
            root: {
                backgroundColor: "#FFFFF",
                boxShadow: "none"
            }
        },
        MuiTableCell: {
            root: {
                padding: 8
            }
        },
        MuiToolbar: {
            root: {
                backgroundColor: "#FFFFFF"
            },
            gutters: {
                [defaultTheme.breakpoints.up("sm")]: {
                    paddingLeft: "15px",
                    paddingRight: "0px"
                },
                paddingLeft: "15px",
                paddingRight: "0px"
            },
            regular: {
                [defaultTheme.breakpoints.up("sm")]: {
                    minHeight: "100px"
                },
                minHeight: "65px"
            }
        },
        MuiTableSortLabel: {
            root: {
                "&:hover": {
                    color: "#FFFFFF"
                },
                "&$active": {
                    color: "#FFFFFF",
                    "&& $icon": {
                        color: "#FFFFFF"
                    }
                }
            }
        }
    }
});

const exportedtheme = responsiveFontSizes(basetheme);
export const theme = exportedtheme;
